export default function trackSearch(query, results, time) {
  let nrOfsearchResults = null;
  if (!results) return;
  Object.values(results).forEach((result) => {
    if (!result) return;
    nrOfsearchResults += result.length;
  });

  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'menu_search',
      event_category: 'menu',
      event_action: 'search',
      event_label: query || null,
      search_keyword: query || null,
      search_results: nrOfsearchResults,
      search_time: time,
    },
  ]);
}
